import { routes as queueRoutes } from "./queue/routes";
import { routes as ipDrugDispensingRoutes } from "./inpatient-queue/routes";
import { routes as dispenseRoutes } from "./dispense/routes";
import { routes as dischargedPatientRoutes } from "./discharged/routes";
import { routes as pharmacyReportRoutes } from "./report/routes";
import { routes as dashboardRoutes } from "./dashboard/routes";

export const routes = [

    ...queueRoutes(),
    ...dispenseRoutes(),
    ...ipDrugDispensingRoutes(),
    ...dischargedPatientRoutes(),
    ...pharmacyReportRoutes(),
    ...dashboardRoutes(),
];
